import React from "react";
import HeaderLinks from "./HeaderLinks";
import "./Header.css";
import headerLogo from "../assets/img/uri_logo.png";
const OerebHeader = () => {
  return (
    <header className="app-header">
      <div className="header-logo">
        <img src={headerLogo} alt="logo of the canton of Uri" />
      </div>
      <div className="header-text-box">
        <h2 data-testid="oereb-header-title" className="header-title">
          ÖREB-Kataster
        </h2>
        <span data-testid="oereb-header-text" className="header-text">
          Der Kataster enthält zuverlässige Informationen über die von Bund und
          Kanton bezeichneten öffentlich-rechtlichen Eigentumsbeschränkungen
          (ÖREB) und macht diese Informationen zugänglich.
        </span>
        <a
          className="header-text-link"
          href="https://www.cadastre.ch/de/oereb.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          <strong> Mehr erfahren</strong>
        </a>
      </div>
      <HeaderLinks />
    </header>
  );
};

export default OerebHeader;
